/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

// Cada variante se exporta con `export const <tipo> =` literal y no armada en
// runtime: scripts/blockly-parity.js detecta generadores con una regex sobre el fuente.

export const base_delay_tren = () => '\ntiempoIniciofuncion = millis();\n';

export const ciudad_tiempo = (block, generator) => (
  ['\n  millis()-tiempoIniciofuncion\n', generator.ORDER_ATOMIC]
);

export const ciudad_ldr = (block, generator) => ['analogRead(A0)', generator.ORDER_ATOMIC];

// Solo declara la función C en definitions_, con una key propia por variante
// para que las 15 convivan sin pisarse.
const funcionCiudadLuces = (defKey, funcName) => (block, generator) => {
  let branch = generator.statementToCode(block, 'DO');
  if (generator.INFINITE_LOOP_TRAP) {
    branch = `${generator.INFINITE_LOOP_TRAP.replace(/%1/g, `'${block.id}'`)}${branch}`;
  }
  generator.definitions_[defKey] = `
  void ${funcName}() {
    static long tiempoIniciofuncion = millis();
    ${branch}
  }
`;
  return '';
};

export const funcion_ciudad_luces = funcionCiudadLuces('def_funcion', 'Secuencia_de_luces_interior');
export const funcion_ciudad_luces2 = funcionCiudadLuces('def_funcion2', 'Secuencia_de_luces_exterior');
export const funcion_ciudad_luces3 = funcionCiudadLuces('def_funcion3', 'Apertura_y_cierre_Flor');
export const funcion_ciudad_luces4 = funcionCiudadLuces('def_funcion4', 'Luminaria_calle');
export const funcion_ciudad_luces5 = funcionCiudadLuces('def_funcion5', 'Pantalla_de_mensajes');
export const funcion_ciudad_luces6 = funcionCiudadLuces('def_funcion6', 'Luminaria_Teatro_col_C3_B3n');
export const funcion_ciudad_luces7 = funcionCiudadLuces('def_funcion7', 'Luminaria_obelisco');
export const funcion_ciudad_luces8 = funcionCiudadLuces('def_funcion8', 'Pantalla_de_mensajes');
export const funcion_ciudad_luces9 = funcionCiudadLuces('def_funcion9', 'Barrera_de_paso');
export const funcion_ciudad_luces10 = funcionCiudadLuces('def_funcion10', 'Estacion_retiro');
export const funcion_ciudad_luces11 = funcionCiudadLuces('def_funcion11', 'Cupula');
export const funcion_ciudad_luces12 = funcionCiudadLuces('def_funcion12', 'Cascada');
export const funcion_ciudad_luces13 = funcionCiudadLuces('def_funcion13', 'Lineal');
export const funcion_ciudad_luces14 = funcionCiudadLuces('def_funcion14', 'Pantalla_de_mensajes');
export const funcion_ciudad_luces15 = funcionCiudadLuces('def_funcion15', 'Exterior');

// El mapeo tipo -> funcName no es 1 a 1 por número: cada línea respeta el del
// legacy, no "ordenarlo".
const otraFuncion = (funcName) => () => `${funcName}();\n`;

export const otra_funcion = otraFuncion('Apertura_y_cierre_Flor');
export const otra_funcion2 = otraFuncion('Secuencia_de_luces_exterior');
export const otra_funcion3 = otraFuncion('Secuencia_de_luces_interior');
export const otra_funcion4 = otraFuncion('Pantalla_de_mensajes');
export const otra_funcion5 = otraFuncion('Luminaria_Teatro_col_C3_B3n');
export const otra_funcion6 = otraFuncion('Luminaria_obelisco');
export const otra_funcion7 = otraFuncion('Luminaria_calle');
export const otra_funcion8 = otraFuncion('Estacion_retiro');
export const otra_funcion9 = otraFuncion('Barrera_de_paso');
export const otra_funcion10 = otraFuncion('Pantalla_de_mensajes');
export const otra_funcion11 = otraFuncion('Cupula');
export const otra_funcion12 = otraFuncion('Cascada');
export const otra_funcion13 = otraFuncion('Lineal');
export const otra_funcion14 = otraFuncion('Pantalla_de_mensajes');
export const otra_funcion15 = otraFuncion('Exterior');
